module.exports = __webpack_public_path__ + "static/media/unlock-badges@2x.d543c4cd.png";